/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Modal size.
 */
export enum MODAL_SIZE {
  /**
   * Extra small size.
   */
  EXTRA_SMALL = 'xs',

  /**
   * Small size.
   */
  SMALL = 'sm',

  /**
   * Regular size.
   */
  REGULAR = '',

  /**
   * Large size.
   */
  LARGE = 'lg',
}
